import { tags } from "@lezer/highlight";
import { createTheme } from "@uiw/codemirror-themes";

//#region src/themes/light.ts
const defaultSettingsVitesseLight = {
	background: "#fff",
	foreground: "#393a34",
	selection: "#22222218",
	selectionMatch: "#22222210",
	gutterBackground: "#f7f7f7",
	gutterForeground: "#393a3450"
};
const createVitesseLightTheme = (options = {}) => {
	const { theme = "light", settings = {}, styles = [] } = options;
	return createTheme({
		theme,
		settings: {
			...defaultSettingsVitesseLight,
			...settings
		},
		styles: [
			{
				tag: [tags.standard(tags.tagName), tags.tagName],
				color: "#1e754f"
			},
			{
				tag: [tags.comment],
				color: "#a0ada0"
			},
			{
				tag: [tags.bracket],
				color: "#999999"
			},
			{
				tag: [tags.className, tags.propertyName],
				color: "#2e8f82"
			},
			{
				tag: [tags.variableName],
				color: "#59873a"
			},
			{
				tag: [tags.attributeName, tags.number],
				color: "#b07d48"
			},
			{
				tag: [tags.typeName],
				color: "#2e8f82"
			},
			{
				tag: [tags.keyword],
				color: "#ab5959"
			},
			{
				tag: [tags.operator, tags.typeOperator],
				color: "#ab5959"
			},
			{
				tag: [tags.string, tags.meta],
				color: "#b56959"
			},
			{
				tag: [tags.regexp],
				color: "#ab5e3f"
			},
			{
				tag: [tags.name],
				color: "#22863a"
			},
			{
				tag: [tags.quote],
				color: "#2e808f"
			},
			{
				tag: [tags.heading, tags.strong],
				color: "#393a34",
				fontWeight: "bold"
			},
			{
				tag: [tags.emphasis],
				color: "#393a34",
				fontStyle: "italic"
			},
			{
				tag: [tags.deleted],
				color: "#b31d28",
				backgroundColor: "ffeef0"
			},
			{
				tag: [
					tags.atom,
					tags.bool,
					tags.special(tags.variableName)
				],
				color: "#1e754f"
			},
			{
				tag: [
					tags.url,
					tags.escape,
					tags.link
				],
				color: "#393a3490"
			},
			{
				tag: tags.link,
				textDecoration: "underline"
			},
			{
				tag: tags.strikethrough,
				textDecoration: "line-through"
			},
			{
				tag: tags.invalid,
				color: "#b31d28",
				fontStyle: "italic"
			},
			...styles
		]
	});
};
const vitesseLight = createVitesseLightTheme();

//#endregion
export { createVitesseLightTheme, defaultSettingsVitesseLight, vitesseLight };